import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../../../stateManager/store';
import { SchemaLayout } from './schemaLayout';
import { DataLabelling } from './dataLabelling';
import { WithOverrides } from '../../components';

export function NLUBasicNLP() {
	const tab =
		useSelector((state: AppState) => state.uiState.selectedBasicNLPTab) ??
		'schema';
	return (
		<WithOverrides>
			{tab === 'schema' && <SchemaLayout />}
			{tab === 'data' && <DataLabelling />}
		</WithOverrides>
	);
}
